import { Colors } from '../../../data/Colors';
import JokeComponent from './JokeComponent';
import React, { ForwardedRef, forwardRef, useMemo } from 'react';
import { GroupProps } from '@react-three/fiber/dist/declarations/src/three-types';
import VectorDisk from './VectorDisk';
import { Group } from 'three';
import { Vector3OrArray } from '../../../types';
import { useDetailViewContext } from '../../../context/DetailViewContext';
import FocusPoints from '../../../data/FocusPoints';
import useLerpedHexColor from '../hooks/useLerpedHexColor';

export type Props = GroupProps & {
    label?: string,
    sphereSize: number,
    sphereCenter: Vector3OrArray,
    arrowOrigin?: Vector3OrArray,
    hideArrow?: boolean,
    flipSide?: boolean,
    sphereTransition?: number,
    azimuth?: number,
};

const LocationSphere = forwardRef(({
  label,
  sphereSize,
  arrowOrigin,
  sphereCenter,
  children,
  hideArrow,
  azimuth,
  sphereTransition,
  flipSide,
  ...props
}: Props, ref?: ForwardedRef<Group>) =>
{

  const { activeFocusID } = useDetailViewContext();

  const t = useMemo(() => activeFocusID === FocusPoints.None ? 0 : 1, [ activeFocusID ]);
  const color = useLerpedHexColor(Colors.LocationVector, Colors.DarkModeGrey, t);
  const diskColor = useLerpedHexColor(Colors.NeutralGrey, Colors.DarkModeGrey, t);
  const textColor = useLerpedHexColor(Colors.White, Colors.White, t);

  return (<JokeComponent {...props} color={color} sphereSize={sphereSize} sphereTransition={sphereTransition}
    sphereCenter={sphereCenter} hideShading
    sphereOutline={0.008} arrowOrigin={arrowOrigin} label={label} ref={ref}>
    <VectorDisk thickness={.002 / sphereSize} color={diskColor} arrowColor={color}
      azimuth={azimuth || 0} textColor={textColor}
      tilt={0} label={label} arrowScale={0.3 / sphereSize} numDots={100 * sphereSize}
      hideArrow={hideArrow} flipSide={flipSide}/>
    {children}
  </JokeComponent>);
});

LocationSphere.displayName = 'LocationSphere';

export default LocationSphere;